import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Menu, MenuService, TitleService } from '@delon/theme';
import { BehaviorSubject, delay, filter, map, merge, Observable, Subscription, take, tap } from 'rxjs';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { CommonModule } from '@angular/common';
import { AuthService, UpdateService } from '@share';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { FirebaseMessagingService } from './share/services/firebase-messaging.service';
import { LoadingService } from './share/services/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NzMenuModule, NzSpinModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [TitleService]
})
export class AppComponent implements OnInit {
  menuChangeSub: Subscription;
  isLoading: Boolean = false;
  currentMessage: any = null;
  loading$: Observable<boolean>;
  private loadingService = inject(LoadingService)
  //private swUpdate = inject(SwUpdate);
  //private firebaseNotificationService: FirebaseNotificationService,
  //private titleService: TitleService, 
  constructor(private readonly authService: AuthService, private readonly updateService: UpdateService, private readonly router: Router, private readonly activatedRoute: ActivatedRoute, private readonly menuService: MenuService) {
    this.loading$ = this.loadingService.loading$;
    const start$ = this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      tap(() => this.isLoading = true)
    );

    // Observable to track navigation end (update title & hide loader)
    const end$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        // Get the deepest child route for title
        let child = this.activatedRoute.firstChild;
        while (child?.firstChild) {
          child = child.firstChild;
        }
        return child?.snapshot.data['title'] || "Smart Taung Thu";
      }),
      tap(title => {
        //this.titleService.setTitle(title);
        this.isLoading = false; // Hide loader
      })
    );
    merge(start$, end$).subscribe();


    this.menuChangeSub = this.menuService.change.subscribe((res) => {
      const sub = this.menuChangeSub; // store current subscription reference
      this.menuChangeSub = null;      // prevent accidental reuse
      sub?.unsubscribe();             // safely unsubscribe

      // this.menuChangeSub.unsubscribe(); // Prevent re-triggering


      res.forEach(item => {
        if (item.children && item.children.some((i: any) => i._selected)) {
          item.open = true;
        }
      });
      this.listenToMenuChanges(); // Re-subscribe
    });
  }

  ngOnInit(): void {

    this.authService.menuState$.subscribe(x => {
      this.menuService.add(x);
    });

  }

  filterMenuByPermissions(menu: any[], permissions: string[]): any[] {
    function hasPermission(item: any): boolean {
      console.log(permissions.includes(`${item.key}.view`));
      return permissions.includes(`${item.key}.view`);
    }

    function filterChildren(items: any[]): any[] {
      return items
        .map(item => {
          console.log(item);
          if (item.children && item.children.length > 0) {
            const filteredChildren = filterChildren(item.children);
            if (filteredChildren.length > 0 || hasPermission(item)) {
              return { ...item, children: filteredChildren };
            }
          } else if (hasPermission(item)) {
            return item;
          }
          return null;
        })
        .filter(item => item !== null);
    }

    return menu
      .map(item => ({
        ...item,
        children: filterChildren(item.children || [])
      }))
      .filter(item => item.children.length > 0 || hasPermission(item));
  }

  getFirstChildLink(menu: any[]): string | null {
    for (const item of menu) {
      if (item.link) {
        return item.link; // Return if item has a direct link
      }
      if (item.children) {
        const childLink = this.getFirstChildLink(item.children); // Recursively check children
        if (childLink) {
          return childLink;
        }
      }
    }
    return null;
  }

  listenToMenuChanges() {
    this.menuService.change.pipe(take(1)) // Take only the first emission
      .subscribe((res) => {
        res.forEach(item => {
          if (item.children && item.children.some((i: any) => i._selected)) {
            item.open = true;
          }
        });
        setTimeout(() => this.menuService.resume(), 0);
      });
  }
}

